import { Link } from 'react-router-dom';

export default function MenuAlumno() {
  return (
    <nav className="bg-white shadow-md px-4 py-2 flex justify-between items-center">
      <h1 className="text-xl font-bold text-blue-600">🏋️ CalisXcore</h1>

      <div className="space-x-4">
        <Link to="/mis-rutinas" className="text-gray-700 hover:text-blue-600 font-medium">
          Mis Rutinas
        </Link>
        <Link to="/progreso" className="text-gray-700 hover:text-blue-600 font-medium">
          Progreso
        </Link>
        <Link to="/rutinas" className="text-gray-700 hover:text-blue-600 font-medium">
          Rutinas Predeterminadas
        </Link>
      </div>
    </nav>
  );
}
